export const all_routes = {
  //region icons
  fontawesome: "/icon-fontawesome",
  feathericon: "/icon-feather",
  ionicicons: "/icon-ionic",
  materialicons: "/icon-material",
  pe7icons: "/icon-pe7",
  simpleline: "/icon-simpleline",
  themifyicons: "/icon-themify",
  iconweather: "/icon-weather",
  typicons: "/icon-typicon",
  flagicons: "/icon-flag",
  remixIcon: "/remix-icon",
  BootstrapIcon: "/bootstrap-icon",
  TablerIcon: "/tabler-icon",

  //region auth
  signin: "/signin",
  forgotPassword: "/forgot-password",

  //region layput demo
  Horizontal: "/layout-horizontal",
  Detached: "/layout-detached",
  Hovered: "/layout-hovered",
  Boxed: "/layout-box",
  Modern: "/layout-modern",
  TwoColumn: "/layout-two-column",
  Dark: "/layout-dark",
  RTL: "/layout-rtl",

  //region Asset Management
  assetmgtassets: "/assetmgt/assets",
  assetmgtassetdetails: "/assetmgt/assetdetails/:assetId",
  assetmgtdashboard: "/assetmgt/dashboard",
  assetmgtbroken: "/assetmgt/broken",
  assetmgtlost: "/assetmgt/lost",
  assetmgtusing: "/assetmgt/using",
  assetmgtunused: "/assetmgt/unused",
  assetmgtliquidation: "/assetmgt/liquidation",
  assetmgtwarrantyrepair: "/assetmgt/warrantyrepair",
  assetmgtsuppliers: "/assetmgt/suppliers",
  assetmgtstatustable: "/assetmgt/assetstatus",

  assetmgtPermissions: "/assetmgt/permissions",
  assetmgtHostAsset: "/assetmgt/AHUList",
  assetmgtAssetItems: "/assetmgt/Filters",
  assetmgtUsers: "/assetmgt/users",
  assetmgtmasters: "/assetmgt/masters/:masterType",
  assetactivitylog: "/assetmgt/activitylog",
  assetmgtlandingpage: "/assetsignin",
  assetmgtUserpermissions: "/assetmgt/userpermissions",
  assetmgtbarcodescanner: "/assetmgt/barcodescanner",
  assetmgtschedule: "/assetmgt/schedule",
  assetmgtreplacementlist: "/assetmgt/replacementlist",
  assetmgtretirementlist: "/assetmgt/retirementlist",
  assetmgtapprovals: "/assetmgt/approvals",
  assetmgtusedashboard: "/user/dashboard",
  assetmgtPasswordpolices: "/assetmgt/password-policies",
  assetmgtUserAccount: "/assetmgt/user-profile",
  assetmgtAlarmsDeviations: "/assetmgt/alarms-deviations",
  assetmgtNotifications: "/assetmgt/notifications",
  assetmgtBackUpRestore: "/assetmgt/backuprestore",
  assetmgtdryerequip: "/assetmgt/dryer-equipment",
  assetmgtwashequip: "/assetmgt/wash-equipment",
  assetmgtmaintenancestages: "/assetmgt/maintenance-stages",
  assetmgtfunctionallocations: "/assetmgt/functional-locations",
  assetmgtassettype: "/assetmgt/filter-types",
  assetmgtwashinreasons: "/assetmgt/wash-in-reasons",
  assetmgtrowaterpressure: "/assetmgt/ro-water-pressure",
  assetmgtairpressure: "/assetmgt/air-pressure-limit",
  assetmgttemperaturerange: "/assetmgt/dryer-temperature-range",
  assetmgtblocks: "/assetmgt/blocks-details",
  assetmgtreports: "/assetmgt/reports/:reportType",
  assetmgtmytasks: "/assetmgt/mytasks",
  assetmgtprinters: "/assetmgt/printers",
  assetmgtdummyreports: "/assetmgt/Reports",
  assetmgtbarcodereport: "/assetmgt/barcodeReport",
  assetmgtauditlogreport: "/assetmgt/auditLogReport",
  assetmgtFilterHistory: "/assetmgt/filterHistoryReport",
  assetmgtfiltercleaning: "/assetmgt/cleaningReport",
  assetmgtdeviationsreport: "/assetmgt/deviationsReport",
  assetmgtdryreport: "/assetmgt/dryingReport",
  assetmgtlocationtypes: "/assetmgt/locationTypes",
  assetmgtUserRequests: "/assetmgt/users-requests",
  assetmgtFilterDryingCleaningReport: "/assetmgt/FilterDryingCleaningReport",
  assetmgtRfidAssign: "/assetmgt/Rfidassign",
  assetmgtInspectionChecklist: "/assetmgt/InspectionChecklist",
  assetmgtChecklistItems: "/assetmgt/ChecklistItems",
  assetmgtAreas: "/assetmgt/Areas",
  assetmgtFiltersTree: "/assetmgt/FiltersTree",
  assetmgtQuery: "/assetmgt/Query",
  assetmgtConfigAudit: "/assetmgt/ConfigAudit",
  assetmgtChecklistReport: "/assetmgt/checklist-report",
};
